export enum FileStatus {
    Load = 'load',
    Done = 'done',
    Download = 'download'
}

export enum FileType {
    Photo = 'photo',
    Video = 'video',
    Word = 'word',
    Excel = 'excel',
    Pdf = 'pdf',
    File = 'file'
}